(function () {
  function parseHTML(html) {
    var parser = new DOMParser();
    return parser.parseFromString(html, 'text/html');
  }

  function setLoading(root, loading) {
    root.classList.toggle('is-loading', loading);
  }

  function closeAllFilters(root) {
    root.querySelectorAll('[data-sim-filter]').forEach(function (filter) {
      filter.classList.remove('is-open');
    });
  }

  function buildSectionURL(root, params) {
    var path = window.location.pathname;
    var sectionId = root.getAttribute('data-section-id');
    var nextParams = new URLSearchParams(params);
    if (sectionId) nextParams.set('section_id', sectionId);
    var query = nextParams.toString();
    return query ? path + '?' + query : path;
  }

  function updateSection(root, url, appendMode, updateHistory) {
    setLoading(root, true);
    fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var nextDoc = parseHTML(html);
        var nextMain = nextDoc.querySelector('[data-sim-main]');
        if (!nextMain) return;

        if (appendMode) {
          var currentGrid = root.querySelector('[data-sim-grid-cards]');
          var nextGrid = nextMain.querySelector('[data-sim-grid-cards]');
          if (currentGrid && nextGrid) {
            currentGrid.insertAdjacentHTML('beforeend', nextGrid.innerHTML);
          }
          var currentPagination = root.querySelector('[data-sim-pagination]');
          var nextPagination = nextMain.querySelector('[data-sim-pagination]');
          if (currentPagination && nextPagination) {
            currentPagination.outerHTML = nextPagination.outerHTML;
          } else if (currentPagination && !nextPagination) {
            currentPagination.remove();
          }
        } else {
          root.innerHTML = nextMain.innerHTML;
          root.setAttribute('data-section-id', nextMain.getAttribute('data-section-id') || '');
          if (updateHistory !== false) {
            history.pushState({}, '', url.replace(/([?&])section_id=[^&]+&?/, '$1').replace(/[?&]$/, ''));
          }
        }

        bind(root);
      })
      .finally(function () {
        setLoading(root, false);
      });
  }

  function formatMoney(raw) {
    var value = Number(raw || 0);
    if (Number.isNaN(value)) value = 0;
    return String.fromCharCode(163) + value.toLocaleString('en-GB');
  }

  function syncListLabel(filterRoot) {
    var triggerLabel = filterRoot.querySelector('[data-sim-filter-label]');
    var trigger = filterRoot.querySelector('[data-sim-filter-trigger]');
    if (!triggerLabel || !trigger) return;

    var checked = filterRoot.querySelectorAll('[data-sim-filter-input]:checked');
    var defaultLabel = trigger.getAttribute('data-default-label') || '';

    if (filterRoot.hasAttribute('data-sim-static-label')) {
      triggerLabel.textContent = defaultLabel;
      return;
    }

    if (!checked.length) {
      triggerLabel.textContent = defaultLabel;
    } else if (checked.length === 1) {
      var optionText = checked[0].closest('.sim-filter__choice');
      triggerLabel.textContent = optionText ? optionText.textContent.trim() : checked[0].value;
    } else {
      triggerLabel.textContent = checked.length + ' selected';
    }
  }

  function syncRangeUI(rangeRoot) {
    var minSlider = rangeRoot.querySelector('[data-sim-range-min]');
    var maxSlider = rangeRoot.querySelector('[data-sim-range-max]');
    var minHidden = rangeRoot.querySelector('[data-sim-range-min-hidden]');
    var maxHidden = rangeRoot.querySelector('[data-sim-range-max-hidden]');
    var minDisplay = rangeRoot.querySelector('[data-sim-range-min-display]');
    var maxDisplay = rangeRoot.querySelector('[data-sim-range-max-display]');
    var progress = rangeRoot.querySelector('[data-sim-range-progress]');
    var filterRoot = rangeRoot.closest('[data-sim-filter]');
    var triggerLabel = filterRoot ? filterRoot.querySelector('[data-sim-filter-label]') : null;
    var trigger = filterRoot ? filterRoot.querySelector('[data-sim-filter-trigger]') : null;

    if (!minSlider || !maxSlider || !minHidden || !maxHidden) return;

    var hardMin = Number(rangeRoot.getAttribute('data-min') || 0);
    var hardMax = Number(rangeRoot.getAttribute('data-max') || 0);
    var min = Number(minSlider.value || hardMin);
    var max = Number(maxSlider.value || hardMax);

    if (min > max) min = max;
    if (max < min) max = min;

    minSlider.value = String(min);
    maxSlider.value = String(max);
    minHidden.value = min > hardMin ? String(min) : '';
    maxHidden.value = max < hardMax ? String(max) : '';

    if (minDisplay) minDisplay.textContent = formatMoney(min);
    if (maxDisplay) maxDisplay.textContent = formatMoney(max);

    if (progress && hardMax > hardMin) {
      var start = ((min - hardMin) / (hardMax - hardMin)) * 100;
      var end = ((max - hardMin) / (hardMax - hardMin)) * 100;
      progress.style.left = start + '%';
      progress.style.width = Math.max(end - start, 0) + '%';
    }

    if (triggerLabel && trigger) {
      var defaultLabel = trigger.getAttribute('data-default-label') || '';
      triggerLabel.textContent = defaultLabel;
    }
  }

  function formParams(form) {
    var params = new URLSearchParams();
    var data = new FormData(form);

    data.forEach(function (value, key) {
      if (value !== '') params.append(key, value);
    });

    params.delete('page');
    return params;
  }

  function bind(root) {
    var loadMore = root.querySelector('[data-sim-load-more]');
    if (loadMore) {
      loadMore.addEventListener('click', function (event) {
        event.preventDefault();
        var href = loadMore.getAttribute('href');
        if (href) updateSection(root, href, true, false);
      });
    }

    var form = root.querySelector('[data-sim-filter-form]');
    if (!form) return;

    root.querySelectorAll('[data-sim-filter]').forEach(function (filterRoot) {
      var trigger = filterRoot.querySelector('[data-sim-filter-trigger]');
      if (!trigger) return;

      trigger.addEventListener('click', function () {
        var wasOpen = filterRoot.classList.contains('is-open');
        closeAllFilters(root);
        if (!wasOpen) filterRoot.classList.add('is-open');
      });
    });

    root.querySelectorAll('[data-sim-filter-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        syncListLabel(input.closest('[data-sim-filter]'));
        form.requestSubmit();
      });
    });

    root.querySelectorAll('[data-sim-range]').forEach(function (rangeRoot) {
      var minSlider = rangeRoot.querySelector('[data-sim-range-min]');
      var maxSlider = rangeRoot.querySelector('[data-sim-range-max]');
      var clear = rangeRoot.querySelector('[data-sim-range-clear]');

      if (!minSlider || !maxSlider) return;

      function onInput(changed) {
        if (Number(minSlider.value) > Number(maxSlider.value)) {
          if (changed === minSlider) {
            maxSlider.value = minSlider.value;
          } else {
            minSlider.value = maxSlider.value;
          }
        }
        syncRangeUI(rangeRoot);
      }

      function onChange() {
        syncRangeUI(rangeRoot);
        form.requestSubmit();
      }

      minSlider.addEventListener('input', function () {
        onInput(minSlider);
      });
      maxSlider.addEventListener('input', function () {
        onInput(maxSlider);
      });
      minSlider.addEventListener('change', onChange);
      maxSlider.addEventListener('change', onChange);

      if (clear) {
        clear.addEventListener('click', function () {
          minSlider.value = rangeRoot.getAttribute('data-min') || '0';
          maxSlider.value = rangeRoot.getAttribute('data-max') || '0';
          syncRangeUI(rangeRoot);
          form.requestSubmit();
        });
      }

      syncRangeUI(rangeRoot);
    });

    root.querySelectorAll('[data-sim-filter]').forEach(function (filterRoot) {
      if (filterRoot.querySelector('[data-sim-range]')) return;
      syncListLabel(filterRoot);
    });

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) closeAllFilters(root);
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      closeAllFilters(root);
      var nextURL = buildSectionURL(root, formParams(form));
      updateSection(root, nextURL, false, true);
    });

    var currentParams = new URLSearchParams(window.location.search);
    if (!currentParams.has('sort_by')) {
      var selectedSort = form.querySelector('input[name="sort_by"]:checked');
      if (selectedSort && selectedSort.value) {
        form.requestSubmit();
      }
    }
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-sim-main]').forEach(function (root) {
      bind(root);
    });
  }

  function refreshFromLocation() {
    document.querySelectorAll('[data-sim-main]').forEach(function (root) {
      var nextURL = buildSectionURL(root, new URLSearchParams(window.location.search));
      updateSection(root, nextURL, false, false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  window.addEventListener('popstate', function () {
    refreshFromLocation();
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();

